import { colors } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { deDE } from '@mui/material/locale';
import shadows from './shadows';
import typography from './typography';

const theme = createTheme(
  {
  palette: {
    background: {
      default: '#fff',
      paper: colors.common.white,
      custom: '#064481'
    },
    primary: {
      contrastText: '#fce531',
      main: '#1b66b3'
    },
    text: {
      primary: '#4a4a4a',
      secondary: '#4a4a4a'
    }
  },
  shadows,
  typography,
},
deDE,
);

export default theme;
